import _ from 'lodash';

export const MOBILE_STATE_TRESHOLD = 767;
export const SMALL_DESKTOP_STATE_TRESHOLD = { from: MOBILE_STATE_TRESHOLD + 1, to: 1200 };

export const DIMENSION_STATES = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
};

export const dimensionStatesArray = Object.values(DIMENSION_STATES);

export const dimensionGate = (dimensionState, callbacks) => {
  switch (dimensionState) {
    case DIMENSION_STATES.MOBILE: {
      const callback = _.get(callbacks, dimensionState, () => {});

      callback();
      break;
    }
    case DIMENSION_STATES.DESKTOP: {
      const callback = _.get(callbacks, dimensionState, () => {});

      callback();
      break;
    }
    default:
      break;
  }
};

export const getDimensions = () => {
  const innerWidth = _.get(window, 'innerWidth', null);
  const innerHeight = _.get(window, 'innerHeight', null);
  const clientWidth = _.get(document, 'documentElement.clientWidth', null);
  const clientHeight = _.get(document, 'documentElement.clientHeight', null);
  const bodyClientWidth = _.get(document, 'body.clientWidth', null);
  const bodyClientHeight = _.get(document, 'body.clientHeight', null);

  const width = innerWidth || clientWidth || bodyClientWidth;
  const height = innerHeight || clientHeight || bodyClientHeight;

  return {
    width,
    height,
    state: width <= MOBILE_STATE_TRESHOLD ? DIMENSION_STATES.MOBILE : DIMENSION_STATES.DESKTOP,
    small_desktop_state:
      width >= SMALL_DESKTOP_STATE_TRESHOLD.from && width <= SMALL_DESKTOP_STATE_TRESHOLD.to,
  };
};

export const getOpenState = (
  currentWindowDimensions,
  nextWindowDimensions = {},
  breakpoint = 992,
  alwaysOpen = true,
) => {
  const { width: currentWidth } = currentWindowDimensions;
  const { width: nextWidth } = nextWindowDimensions;

  let open = null;

  if (currentWidth > nextWidth && nextWidth < breakpoint) {
    open = alwaysOpen || false;
  } else {
    if (nextWidth >= breakpoint && currentWidth > breakpoint) {
      open = true;
    } else if (nextWidth < breakpoint && currentWidth < breakpoint) {
      open = false;
    }

    if (alwaysOpen) {
      open = true;
    }
  }
  return { open };
};
